import { useEffect, useState } from 'react';

export const useUser = () => {
    const [localUser, setLocalUser] = useState(null);
    const getUser = () => {
        const user = localStorage.getItem('user');
        if (!user) return null;
        return JSON.parse(user);
    }
    const setUser = (user) => {
        if (!user) return;
        localStorage.setItem('user', JSON.stringify(user));
    }
    const unSetUser = () => {
        localStorage.setItem('user', null);
    }

    // Initial fetch of user
    useEffect(() => {
        const user = getUser();
        if (user) {
            setLocalUser(user);
        }
    }, [])


    return {
        user: localUser,
        getUser,
        setUser,
        unSetUser
    }
}